module.exports = __webpack_public_path__ + "img/main.30469155.png";